var _circle, _rect, _path, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#DFE2EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.1836,
    y: 30.2627,
    width: 52.6316,
    height: 39.4737,
    rx: 4.56,
    fill: "white",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1836 36.8418L49.6787 48.3146C50.2006 48.5495 50.7982 48.5495 51.3201 48.3146L76.8152 36.8418",
    stroke: "#20242E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.8682,
    cy: 63.1583,
    r: 14.4737,
    fill: "#0E5CF4",
    stroke: "#20242E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3398 63.316C68.3398 64.5584 68.8334 65.7498 69.7118 66.6283C70.5903 67.5067 71.7817 68.0002 73.024 68.0002C74.2664 68.0002 75.4578 67.5067 76.3363 66.6283C77.2147 65.7498 77.7083 64.5584 77.7083 63.316C77.7083 62.0737 77.2147 60.8823 76.3363 60.0038C75.4578 59.1253 74.2664 58.6318 73.024 58.6318C71.7817 58.6318 70.5903 59.1253 69.7118 60.0038C68.8334 60.8823 68.3398 62.0737 68.3398 63.316Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7089 63.3277V64.8891C77.7089 65.5793 77.7338 66.2412 78.2218 66.7292C78.7098 67.2173 79.1005 67.4914 79.7907 67.4914C80.4809 67.4914 81.1428 67.2173 81.6309 66.7292C82.1189 66.2412 82.3931 65.5793 82.3931 64.8891V63.3277C82.3956 61.3147 81.7497 59.3543 80.551 57.7371C79.3523 56.1198 77.6645 54.9317 75.7377 54.3487C73.8109 53.7657 71.7476 53.8189 69.8534 54.5003C67.9592 55.1818 66.3348 56.4552 65.221 58.1321C64.1071 59.8089 63.5631 61.7999 63.6693 63.8102C63.7756 65.8204 64.5265 67.743 65.8109 69.2931C67.0953 70.8431 68.8449 71.9383 70.8004 72.4162C72.7559 72.8942 74.8133 72.7295 76.6679 71.9466",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredEnvelope);
export default __webpack_public_path__ + "static/media/ic-colored-envelope.6c0dc52920abbfb5e1febea69350e2eb.svg";
export { ForwardRef as ReactComponent };